import { z } from 'zod'

export const supplierInstallationEmissionReportProductionRouteValues = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
] as const

export type SupplierInstallationEmissionReportProductionRoute =
  (typeof supplierInstallationEmissionReportProductionRouteValues)[number]

export const supplierInstallationEmissionReportProductionRouteLabels = {
  A: 'Grey clinker / cement',
  B: 'White clinker / cement',
  C: 'Carbon steel based on BF/BOF',
  D: 'Carbon steel based on DRI/EAF',
  E: 'Carbon steel based on Scrap/EAF',
  F: 'Low alloy steel based on BF/BOF',
  G: 'Low alloy steel based on DRI/EAF',
  H: 'Low alloy steel based on Scrap/EAF',
  J: 'High alloy steel (based on EAF)',
  K: 'Primary aluminium',
  L: 'Secondary aluminium',
} as const satisfies Record<
  SupplierInstallationEmissionReportProductionRoute,
  string
>

export function formatSupplierInstallationEmissionReportProductionRouteLabel(
  route: SupplierInstallationEmissionReportProductionRoute
): string {
  return `${route} — ${supplierInstallationEmissionReportProductionRouteLabels[route]}`
}

export const supplierInstallationEmissionReportProductionRouteSchema = z.enum(
  supplierInstallationEmissionReportProductionRouteValues
)
